import React from "react";

const WidgetTabPanel = (props) => {
    return (
        <div className={"tab-panel"} id={props.id} role="tabpanel">
            {props.children}
        </div>
    )
}
export default WidgetTabPanel